export type Section = {
  title: string;
  intro?: string; // HTML allowed
  bullets?: string[]; // each may contain HTML
};

function ModuleSection({ section }: { section: Section }) {
  return (
    <div className="w-full mt-4 text-normal">
      <div className="text-lg border-b border-light-border">{section.title}</div>
      {section.intro && (
        <div
          className="mt-2 text-light-text"
          dangerouslySetInnerHTML={{ __html: section.intro }}
        />
      )}
      {section.bullets && (
        <ul className="list-disc list-inside space-y-2 mt-2">
          {section.bullets.map((b, i) => (
            <li key={i} dangerouslySetInnerHTML={{ __html: b }} />
          ))}
        </ul>
      )}
    </div>
  );
}

export default ModuleSection;